import 'react';
import { Image, Button } from 'reaxl';
import { eventBus } from '@atc/cai-event-bus';
import { OPEN_WALLET } from 'wallet-manager';
import { jsxs, jsx } from 'react/jsx-runtime';
function KBBTradeInCTA(_ref) {
  let {
    enableTradeIn,
    onClick = () => {},
    source,
    handleNDSClick,
    onFetchPersonalizedPaymentDetails,
    updateMyWallet
  } = _ref;
  if (!enableTradeIn) {
    return null;
  }
  const onTradeInLinkClick = event => {
    handleNDSClick(event, {
      userModified: 'GET_TRADE_IN_VALUE_LINK_CLICKED',
      elementText: 'Get Trade In Value'
    });
    const kbbTradePanelInfo = {
      selectedPanelName: 'kbbValuation',
      hideBackButton: true
    };
    if (onFetchPersonalizedPaymentDetails) {
      // Syndication
      eventBus.emit(OPEN_WALLET, kbbTradePanelInfo);
    } else {
      // Remove this and in AT/KBB add the listener to support OPEN_WALLET event
      updateMyWallet({
        displayModal: true,
        ...kbbTradePanelInfo
      });
    }
    onClick(event);
  };
  return /*#__PURE__*/jsxs("div", {
    className: "margin-bottom-4 display-flex",
    children: [/*#__PURE__*/jsx("div", {
      className: "margin-right-1",
      children: /*#__PURE__*/jsx(Image, {
        alt: "KBB logo",
        height: 17,
        src: "https://www.autotrader.com/cm-api/content/static/img/icon/logos/kbb-logo-notext.svg",
        width: 14
      })
    }), /*#__PURE__*/jsxs(Button, {
      onClick: event => onTradeInLinkClick(event),
      bsStyle: "text",
      children: [source === 'KBB' ? 'Update' : 'Get', " My Kelley Blue Book\xAE Value"]
    })]
  });
}
export { KBBTradeInCTA as default };
